// 'direct'/'proxy' are explicit overrides; 'auto' infers from how the app is served: an HTTPS page
// is the public proxy-fronted deployment (proxy), anything else (http from a VPN IP, dev) is direct.
export default function resolveConnectionMode(setting) {
  if (setting === 'direct' || setting === 'proxy') return setting;

  return typeof window !== 'undefined' && window.location.protocol === 'https:' ? 'proxy' : 'direct';
}
